<template>
  <v-container fluid tag="section">
    <base-material-card
      color="primary"
      inline
      icon="mdi-chart-bell-curve"
      class="ml-4 px-5 py-3"
      title="Desvio Padrão"
      elevation="0"
    >
      <v-row class="mt-3" justify="space-between">
        <v-col cols="12" md="auto">
          <div
            class="text-subtitle-1 font-weight-medium mb-2 grey--text body-2"
          >
            Competência
          </div>
          <div class="d-flex align-center">
            <input-month
              rules="min:7"
              :minMonth="'2023-01'"
              :selectedMonth="competenciaDe"
              @monthSelected="setCompetenciaDe"
              outlined
              dense
              class="mr-4"
            />
            <span
              class="mx-3 grey--text body-2"
            >
              até
            </span>
            <input-month
              rules="min:7"
              :minMonth="'2023-01'"
              :selectedMonth="competenciaAte"
              @monthSelected="setCompetenciaAte"
              outlined
              dense
            />
          </div>
        </v-col>

        <v-col cols="6" sm="3">
          <v-select
            :disabled="false"
            :items="bases"
            :value="baseSelecionada"
            @change="setBaseSelecionada($event)"
            label="Base"
            class="mt-0 pt-1"
            hide-details
            outlined
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-checkbox
            label="Mostrar linhas com Mediana zerada"
            :input-value="showZeroMedian"
            @change="setShowZeroMedian($event)"
            hide-details
          />
        </v-col>
      </v-row>

      <v-row class="mb-8" justify="center">
        <v-col cols="12">
          <select-temas-indger
            :panels="[0, 1]"
            :baseSelecionada="baseSelecionada"
            :initialSelectedFields="selectedFields"
            :initialSelectedTiposServicos="selectedTiposServicos"
            @selectedFields:changed="selectingFields = $event"
            @selectedTiposServicos:changed="selectingTiposServicos = $event"
          />
        </v-col>
        <v-col cols="auto" class="pt-0" v-if="shouldShowApplyButton">
          <v-btn color="primary" @click="applyFilters()">
            <v-icon left>mdi-check</v-icon>
            Aplicar
          </v-btn>
        </v-col>
      </v-row>

      <v-row no-gutters justify="center">
        <v-col cols="auto" class="body-1">
          Foram encontrados
          <b :class="dadosZscore.length > 0 ? 'error--text' : 'success--text'">
            {{ dadosZscore.length }}
          </b>
          outliers com os parâmetros selecionados.
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table
            class="borda"
            :loading="loading"
            :headers="headers"
            :items="dadosZscore"
            :search="search"
            multi-sort
            :footer-props="{
              showFirstLastPage: true,
              showCurrentPage: true,
              itemsPerPageOptions: [5, 15, 50, 100, 1000],
            }"
          >
            <template v-slot:top>
              <v-row class="mx-auto" justify="space-between">
                <v-col cols="6" sm="3">
                  <v-text-field
                    v-model="search"
                    label="Pesquisar"
                    single-line
                    hide-details
                    prepend-icon="mdi-magnify"
                    clearable
                  />
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    color="primary"
                    outlined
                    class="mt-2"
                    @click="downloadXLSX"
                    :loading="downloading"
                    :disabled="loading"
                  >
                    <v-icon left size="30px">
                      mdi-microsoft-excel
                    </v-icon>
                    Exportar XLSX
                  </v-btn>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.mes`]="{ item }">
              {{ item.mes | addLeadingZero }}
            </template>
            <template v-slot:[`item.indicador`]="{ item }">
              {{ item.indicador | toUpperCase }}
            </template>
            <template v-slot:[`item.valor`]="{ item }">
              {{ item.valor | parseNumberToFloatBrIgnoringNaN }}
            </template>
            <template v-slot:[`item.stddev`]="{ item }">
              {{ item.stddev | parseNumberToFloatBrIgnoringNaN }}
            </template>
            <template v-slot:[`item.outlier_down`]="{ item }">
              {{ item.outlier_down | parseNumberToFloatBrIgnoringNaN }}
            </template>
            <template v-slot:[`item.median`]="{ item }">
              {{ item.median | parseNumberToFloatBrIgnoringNaN }}
            </template>
            <template v-slot:[`item.outlier_up`]="{ item }">
              {{ item.outlier_up | parseNumberToFloatBrIgnoringNaN }}
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </base-material-card>

    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
  </v-container>
</template>

<script>
import ZscoreService from "@/services/ZscoreService";
import { mapState, mapActions } from "vuex";

export default {
  name: "ZScoreIndex",
  components: {
    InputMonth: () => import("@/components/general/InputMonth.vue"),
    SelectTemasIndger: () =>
      import("@/components/general/SelectTemasIndger.vue"),
  },
  data() {
    return {
      bases: [
        { text: "COMERCIAL", value: "comercial" },
        { text: "SERVIÇOS", value: "servicos" },
        { text: "ALIMENTADORES", value: "tec_al" },
        { text: "SUBESTAÇÕES", value: "tec_sub" },
        { text: "LINHAS DE DISTRIBUIÇÃO", value: "tec_ld" },
      ],
      loading: false,
      downloading: false,
      dadosZscore: [],
      search: "",
      selectingFields: [],
      selectingTiposServicos: [],
    };
  },
  computed: {
    ...mapState("parametrosZscore", [
      "competenciaDe",
      "competenciaAte",
      "baseSelecionada",
      "selectedFields",
      "selectedTiposServicos",
      "showZeroMedian",
    ]),
    headers() {
      return this.getHeaders(this.baseSelecionada);
    },
    fieldsIsDirty() {
      return (
        JSON.stringify(this.selectingFields) !==
        JSON.stringify(this.selectedFields)
      );
    },
    tiposServicosIsDirty() {
      return (
        JSON.stringify(this.selectingTiposServicos) !==
        JSON.stringify(this.selectedTiposServicos)
      );
    },
    shouldShowApplyButton() {
      return (
        this.fieldsIsDirty ||
        (this.baseSelecionada === "servicos" && this.tiposServicosIsDirty)
      );
    },
  },
  created() {
    this.loading = true;
    this.setRangeCompetencias();
  },
  mounted() {
    // Recupera valor inicial que está salvo no Vuex
    this.selectingFields = this.selectedFields;
    this.selectingTiposServicos = this.selectedTiposServicos;

    this.getZscore();
  },
  methods: {
    ...mapActions("parametrosZscore", [
      "setRangeCompetencias",
      "setCompetenciaDe",
      "setCompetenciaAte",
      "setBaseSelecionada",
      "setSelectedFields",
      "setSelectedTiposServicos",
      "setShowZeroMedian",
    ]),
    applyFilters() {
      this.setSelectedFields(this.selectingFields);
      this.setSelectedTiposServicos(this.selectingTiposServicos);

      this.getZscore();
    },
    getZscore() {
      this.loading = true;
      this.dadosZscore = [];

      return ZscoreService.getZscore(
        this.competenciaDe,
        this.competenciaAte,
        this.baseSelecionada,
        this.showZeroMedian,
        this.selectedFields,
        this.selectedTiposServicos
      )
        .then((res) => {
          this.dadosZscore = res;
        })
        .catch((err) => {
          this.$toast.error("Erro ao buscar dados.", "", {
            position: "topRight",
          });
          throw err;
        })
        .finally(() => (this.loading = false));
    },
    downloadXLSX() {
      this.downloading = true;

      this.$toast.info("Processando arquivo, por favor, aguarde.", "", {
        position: "topRight",
        timeout: 2000,
      });

      ZscoreService.downloadXlsxZscore(
        this.competenciaDe,
        this.competenciaAte,
        this.baseSelecionada,
        this.showZeroMedian,
        this.selectedFields,
        this.selectedTiposServicos,
        { timeout: 60 * 60 * 1000 }
      )
        .then((res) => {
          const blob = new Blob([res], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `outliers_${this.baseSelecionada}-${this.competenciaDe}_${this.competenciaAte}.xlsx`;
          a.click();
        })
        .catch((err) => {
          this.$toast.error("Erro ao baixar o arquivo.", "", {
            position: "topRight",
          });
          throw err;
        })
        .finally(() => (this.downloading = false));
    },
    getHeaders(base) {
      const cod_tec = {
        tec_al: "Alimentador",
        tec_sub: "Subestação",
        tec_ld: "Linha de Distribuição",
      };

      switch (base) {
        case "comercial":
          return [
            { text: "Município", value: "nome_municipio" },
            { text: "Mês", value: "mes" },
            { text: "Ano", value: "ano" },
            { text: "Indicador", value: "indicador" },
            { text: "Valor", value: "valor" },
            { text: "Desvio Padrão", value: "stddev" },
            { text: "Limite inferior", value: "outlier_down" },
            { text: "Mediana", value: "median" },
            { text: "Limite superior", value: "outlier_up" },
          ];
        case "tec_al":
        case "tec_sub":
        case "tec_ld":
          return [
            { text: "Codígo Conjunto", value: "cod_conj" },
            { text: "Mês", value: "mes" },
            { text: "Ano", value: "ano" },
            { text: cod_tec[base], value: "cod_tec" },
            { text: "Indicador", value: "indicador" },
            { text: "Valor", value: "valor" },
            { text: "Desvio Padrão", value: "stddev" },
            { text: "Limite inferior", value: "outlier_down" },
            { text: "Mediana", value: "median" },
            { text: "Limite superior", value: "outlier_up" },
          ];
        case "servicos":
          return [
            { text: "Município", value: "nome_municipio" },
            { text: "Mês", value: "mes" },
            { text: "Ano", value: "ano" },
            { text: "Tipo de Serviço", value: "tipo_servico" },
            { text: "Indicador", value: "indicador" },
            { text: "Valor", value: "valor" },
            { text: "Desvio Padrão", value: "stddev" },
            { text: "Limite inferior", value: "outlier_down" },
            { text: "Mediana", value: "median" },
            { text: "Limite superior", value: "outlier_up" },
          ];
        default:
          return [];
      }
    },
  },
  watch: {
    competenciaDe() {
      this.getZscore();
    },
    competenciaAte() {
      this.getZscore();
    },
    baseSelecionada() {
      this.loading = true;
      setTimeout(() => {
        this.applyFilters();
      }, 300);
    },
    showZeroMedian() {
      this.getZscore();
    },
  },
};
</script>

<style>
  .borda {
    border: 2px solid rgba(0, 0, 0, 0.1);
    border-radius: 4px;
  }
</style>
